"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tariff = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const iconItemConfig_1 = require("./iconItemConfig");
exports.tariff = {
    title: 'Economy',
    detailsConfig: [
        iconItemConfig_1.iconItemsConfig.briefcaseEconomy,
        iconItemConfig_1.iconItemsConfig.baggageEconomy,
    ],
    detailedDescription: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/economy:DetailedDescription', description: 'Rate `economy` detailed HTML description', defaultMessage: '<p>Economy Class includes one piece of baggage and one piece of hand baggage. Please consider the baggage restrictions.</p><p>All stated times are local times at the origin of departure.</p><p>The listed price is for one flight per adult person. Depending on the selected payment method, additional fees may apply.  Please be aware that prices are subject to change until the booking is confirmed.</p>', values: {
            p: (chunk) => react_1.default.createElement("p", null, chunk),
        } })),
};
//# sourceMappingURL=economy.js.map